<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container" :class="{ 'modal--wider': wider }">
          <div class="modal-body" ref="modalBody">
            <!--ModalContent komponenta-->
            <component :is="componentName" />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('modal', ['componentName', 'wider'])
  },
  updated() {
    // scroll to top so the modal is fully visible
    window.scrollTo(0, 0);
    this.$refs.modalBody.scrollTop = 0;
  }
};
</script>

<style lang="scss">
.modal-mask {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  // display: table-cell;
  // vertical-align: middle;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-container {
  /*width: 600px;*/
  width: 700px;
  max-height: 95vh;
  margin: 0px auto;
  padding: 30px 30px 15px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  position: absolute;
  top: 50vh;
  // left: 50%;
  left: calc(50% + 9vw);
  transform: translate(-50%, -50%);
  & > .modal-body {
    padding-top: 0px !important;
  }
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-header {
  padding-top: 0px !important;
  padding-left: 0px !important;
  position: sticky;
  top: 0;
  background: white;
  z-index: 9;
  padding: 0 !important;
}

.modal-body {
  padding-top: 10px;
  // margin: 20px 0;
  // margin-bottom: 10px;
  max-height: calc(100vh - 100px);
  // padding-left: 3px !important;
  overflow-y: auto;
  .btn {
    min-width: 72px;
  }
}

.modal--wider {
  width: 70vw;
  left: 47%;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.footer {
  text-align: right !important;
}

p {
  margin: 0 !important;
}
</style>
